import React,{ useContext  } from 'react';
import {Image, Form, Col,Button} from 'react-bootstrap';
import {  Navigate, useNavigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import { useSelector,useDispatch } from 'react-redux';
import { setStateGlobal, showAlert, } from '../../reducers/appReducer';

import { AuthContext } from '../../auth/AuthContext';
import { types } from '../../types/types';

export const Login = () => {

    const navigate = useNavigate();

    const { usuario, dispatch } = useContext(AuthContext);

    const stateGlobal = useSelector( (state) => state.agents );
    const { array_usuarios } = stateGlobal;
    const dispatchRedux = useDispatch();

    const handleSubmit = (e) => {
        e.preventDefault();
        const correo = e.target.correo.value;
        const password = e.target.password.value;
        
        const newArrayUsuarios = [...array_usuarios];
        const isLogged = {}

        newArrayUsuarios.filter( element => {
            if(element.correo === correo && element.password === password) {
              isLogged.tipo_usuario = element.tipo_usuario
              isLogged.nombre = element.nombre
            }
            return element;
          })

        if(isLogged.tipo_usuario) {
          dispatch({ 
            type: types.login,
            payload: {
              tipo_usuario : isLogged.tipo_usuario,
              nombre: isLogged.nombre
            }
          });
          dispatchRedux( setStateGlobal({ logged: true, tipo_usuario: isLogged.tipo_usuario, nombre: isLogged.nombre, }) )
          if(isLogged.tipo_usuario==='1'){
            navigate("/")
            return false;
          }
          if(isLogged.tipo_usuario==='2'){
            navigate("/homeCaja")
            return false;
          }
          if(isLogged.tipo_usuario==='3'){
            navigate("/homeFinanzas")
            return false;
          }
          if(isLogged.tipo_usuario==='4'){
            navigate("/homeProcesos")
            return false;
          }
          if(isLogged.tipo_usuario==='5'){
            navigate("/")
            return false;
          }
        } else {
          alert('Lo sentimos, el correo electrónico o contraseña es incorrecto.')
        }

    }

    if(usuario.logged){
        if(usuario.tipo_usuario==='1'){
            return <Navigate to="/" />
        }
        if(usuario.tipo_usuario==='2'){
            return <Navigate to="/homeCaja" />
        }
        if(usuario.tipo_usuario==='3'){
            return <Navigate to="/homeFinanzas" />
        }
        if(usuario.tipo_usuario==='4'){
            return <Navigate to="/homeProcesos" />
        }
        if(usuario.tipo_usuario==='5'){
            return <Navigate to="/" />
        }
    }

    return (
        <div>
        <Toaster position='top-right' />
            <div className="container-fluid" style={{paddingTop: '50px',backgroundColor:'#f4244c', height:'100vh'}}>
                <div className="row justify-content-center">
                    <Col xs={12} className="text-center">
                        <Image src={`/img/logo_interbrokers.png`} alt="arya-logo"
                        style={{ maxWidth: 250, textAlign: 'center', marginBottom:'20px' }}
                        />   
                    </Col>
                    <div className="col-10 col-md-6 col-lg-4">
                        <div className="ws-box-container" 
                        style={{ 
                            border: "8px solid rgb(171 170 170 / 40%)",
                            borderRadius: '6px',
                            textAlign:'center',
                            padding: '20px'
                        }}>

                            <div className="tile-title-w-btn">
                                <h3 className="text-center" style={{fontWeight:'700'}}>Iniciar sesión</h3>
                            </div>

                            <Form onSubmit={(e) => handleSubmit(e)} className="text-start">
                                <Form.Group className="mb-3">    
                                    <Form.Label>Correo</Form.Label>
                                    <Form.Control type="text" name="correo" id="correo" placeholder="Ingresa el correo electrónico" required />
                                </Form.Group>
                                <Form.Group className="mb-3">    
                                    <Form.Label>Contraseña</Form.Label>
                                    <Form.Control type="password" name="password" id="password" placeholder="Ingresa la contraseña" required />
                                </Form.Group>
                                <Form.Group className="mb-2">
                                    <div className="d-grid gap-2">   
                                        <Button type="submit" className="ws-btn-blue-2 btn btn-primary" size="lg" >Entrar</Button>
                                    </div>
                                </Form.Group>
                            </Form>
{/* 
                            <form id="formPhone" className='mt-4'>
                                <div className="row">
                                    <div className="col-md-12">
                                        <label className="control-label mb-2"><b>Teléfono</b></label>
                                        <div className='cnt-options'>
                                            <input  name="telefono" type="text" placeholder="Teléfono" required />
                                        </div>
                                    </div>

                                    <div className="col-md-12" id="divMessageFormPhone"></div>

                                    <div className="col-md-12">
                                        <div className="form-group mt-3">
                                            <button type="submit" className="button ws-btn-secondary"
                                            style={{width:'100%'}} name="btn">Entrar</button>
                                        </div>
                                    </div>

                                </div>
                            </form> */}

                            {/* <form id="formToken" style={{display:'none'}}>
                                <div className="row">
                                    <div className="col-md-12">
                                            <label className="control-label"><b>Token de acceso</b></label>
                                            <div className='cnt-options'>
                                                <input name="token" type="text" placeholder="Token" required />
                                            </div>
                                            <small>Escribe el token que hemos enviado a tu whatsapp</small>
                                    </div>

                                    <div className="col-md-12" id="divMessageFormToken"></div>

                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <button type="submit" className="button ws-btn-secondary" style={{width:'100%'}} name="btn">Entrar</button>
                                        </div>
                                    </div>

                                </div>
                            </form> */}


                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
